<div class="loading-spinner__ring">
  <mat-progress-spinner
    color="primary"
    mode="indeterminate"
    [attr.aria-label]="accessibleLabel()"
    [attr.aria-busy]="true"
    [attr.aria-valuemin]="0"
    [attr.aria-valuemax]="100" />
</div>

<div class="loading-spinner__text">
  <div #ref><ng-content /></div>
  @if (!ref.children.length && spinnerTitle()) {
    <h4>{{ spinnerTitle() }}</h4>
  }
</div>
